import { AnimatedInfiniteSlantedCards } from "@with-nx/simple-ui/organisms";
import { Box } from "simple-effing-primitive-layout";

export const BackdropsAnimations = ({ mobile }) => {
  const images = [...Array(72)].map((_, i) => `/assets/drops/${i + 1}.jpg`);

  return (
    <Box parse={`p:relative mh:${mobile ? "600" : "820"} z:2 pt:73 oa:hidden`}>
      <Box
        parse="p:absolute w:100% h:100% t:0 l:0 z:2"
        style={{
          background: mobile
            ? ""
            : "linear-gradient(90deg, var(--background) 0%, rgba(23, 27, 32, 0) 51.5%, var(--background) 100%)",
        }}
      />

      <Box
        parse={`oa:visible p:absolute t:0 l:0 z:0`}
        style={{ transform: "translate(-50%, 10vw) rotate(-7deg)" }}
        id="animated-cards"
      >
        <AnimatedInfiniteSlantedCards images={images} size={8} />
      </Box>
    </Box>
  );
};
